module.exports = __webpack_public_path__ + "static/carousel-1-d080d93ddda63d69f88ce67c9e619632.jpg";